/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { textAlignRight } from './style.js'
import React from 'react'
import { fmt, Fields } from '../twd/twd'
import { getAccounts, useOrderTicket, MODES, STEPS} from './use-order-ticket'

export const Account = () => {

    const {step, acctNo, setAcctNo, orderInfo, hasOrderInfo, accountInfo, hasAccountInfo, mode} = useOrderTicket()

    const isEntry = step===STEPS.ENTRY
    const isPreview = step===STEPS.PREVIEW ||  step===STEPS.CONFIRM

    const purchasingPowerLabel = isEntry ? 'Pre-trade purchasing power'
        : isPreview ? 'Post-trade purchasing power'
        : null

    const purchasingPower = (isEntry && hasAccountInfo) ? accountInfo.purchasingPower
        : (accountInfo.purchasingPower && isPreview && hasOrderInfo && orderInfo.action==='S') ? (accountInfo.purchasingPower + orderInfo.netMoney)
        : (accountInfo.purchasingPower && isPreview && hasOrderInfo && orderInfo.action==='B') ? (accountInfo.purchasingPower - orderInfo.netMoney)
        : null

    return <React.Fragment>
        <div className="row vertical-offset-base"></div>
        <div className="row">

        <div className="col-md-3 col-xs-12 vertical-offset-sm">
            {isEntry && <SelectAccount {...{acctNo, setAcctNo, accounts:getAccounts(), mode}} /> }
            {isPreview && <ShowAccount {...{acctNo, accounts:getAccounts()}}/> }
        </div>

        <div className="col-md-6 col-xs-12"></div>

        {hasOrderInfo && <div
            className="col-md-3 col-xs-12 vertical-offset-sm"
            css={textAlignRight}
        >
            <div>{purchasingPowerLabel}</div>
            <div className="text-bold">{fmt.money(purchasingPower)}</div>
        </div>}
        </div>
        </React.Fragment>
}

const ShowAccount = ({acctNo, accounts}) => {

    const detail = accounts.filter(a => a.acctNo===acctNo)[0] || {acctNo}

    return <React.Fragment>
        <div>Account</div>
        <div className="text-truncate"><b>{ detail.title }</b></div>
    </React.Fragment>
}


const SelectAccount = ({acctNo, accounts, setAcctNo, mode}) => {

    const canEdit = mode!==MODES.ORDER_Z

    return <Fields.SelectMulti
        dataName="order-ticket-account"
        label={"Account"}

        emptyText='Select account'
        allText=''
        disabled={!canEdit}

        showSelectAll={false}
        isMultiSelect={false}

        options={ accounts.map(a => ({ label:a.title, value:a.acctNo, })) }
        style={{marginBottom:'0px'}}
        optionCheckboxLabelConfig={{
            className:"text-truncate",
        }}

        placeholder={({emptyText, allText, values, options}) => {
            const a = options.filter(({value}) => value===acctNo)[0]
            return (a && a.label) || emptyText
        }}

        onSelect={(acct) => {
            setAcctNo(acct.value)
        }}
    />
}


// WEBPACK FOOTER //
// ./src/order-ticket/account.js